module.exports = __webpack_public_path__ + "static/img/strong.69cd1676.svg";